import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CrudList from "@/components/CrudList";

export default function Maintenance() {
  const [assets, setAssets] = useState([]);
  useEffect(() => { api.get("/assets").then((r) => setAssets(r.data)); }, []);
  return (
    <CrudList
      title="Maintenance Alat Berat"
      subtitle="Jadwal & log perawatan preventive / corrective"
      endpoint="/maintenance"
      exportModule="maintenance"
      importable={false}
      columns={[
        { key: "date", label: "Tanggal" },
        { key: "asset_id", label: "Aset", render: (r) => assets.find((a) => a.id === r.asset_id)?.code || "-" },
        { key: "type", label: "Tipe" },
        { key: "status", label: "Status" },
        { key: "cost", label: "Biaya", render: (r) => "Rp " + (r.cost || 0).toLocaleString('id-ID') },
        { key: "description", label: "Deskripsi" },
      ]}
      fields={[
        { key: "date", label: "Tanggal", type: "date", required: true },
        { key: "asset_id", label: "Aset", type: "select", options: assets.map((a) => ({ value: a.id, label: `${a.code} - ${a.name}` })), required: true },
        { key: "type", label: "Tipe", type: "select", options: [
          { value: "preventive", label: "Preventive" },
          { value: "corrective", label: "Corrective" },
        ], required: true },
        { key: "status", label: "Status", type: "select", options: [
          { value: "planned", label: "Direncanakan" },
          { value: "in_progress", label: "Berlangsung" },
          { value: "done", label: "Selesai" },
        ] },
        { key: "cost", label: "Biaya (Rp)", type: "number" },
        { key: "description", label: "Deskripsi", required: true, wide: true },
      ]}
    />
  );
}
